module.exports = __webpack_public_path__ + "img/ic_burger_athleten-active.c5b19f49.svg";